/* eslint-disable import/no-cycle */
import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { DELETE, GET, POST, PUT } from "../../../helpers/apiHelper";
import {
  SuccessCreate,
  SuccessDelete,
  SuccessUpdate,
} from "../../../helpers/toastHelper";

import * as action from "./action";

export const getListState = (state) => state.documentTypeApp.list;

const loadMasterDocumentAsync = async (query) => GET(`/documentType?${query}`);

const addMasterDocumentAsync = async (item) => POST(`/documentType`, item);
const editMasterDocumentAsync = async (id, item) => PUT(`/documentType/${id}`, item);
const deleteMasterDocumentAsync = async (id) => DELETE(`/documentType/${id}`);

function* loadMasterDocumentList({ payload }) {
  try {
    const list = yield select(getListState);
    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "orderBy",
        value: list.orderBy,
      },
      {
        name: "sortedBy",
        value: list.sortedBy,
      },
      {
        name: "limit",
        value: payload.limit,
      },
    ];

    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
          {
            name: "searchFields",
            value: list.filterFields,
          },
          {
            name: "searchJoin",
            value: list.searchJoin,
          },
        ],
      ];
    }
    const response = yield call(
      loadMasterDocumentAsync,
      param.map((t) => `${t.name}=${t.value}`).join("&")
    );
    yield put(action.loadMasterDocumentListSuccess(response));
  } catch (error) {
    yield put(action.loadMasterDocumentListError(error));
  }
}

function* saveAddeditMasterDocument({ payload }) {
  let response = null;
  try {
    if (payload.item) {
      if (payload.mode === "edit") {
        response = yield call(
          editMasterDocumentAsync,
          payload.item.id,
          payload.item
        );
      } else if (payload.mode === "add") {
        response = yield call(addMasterDocumentAsync, payload.item);
      } else {
        throw new Error("invalid mode");
      }
      yield put(action.saveAddeditMasterDocumentSuccess(response));
      yield put(action.loadMasterDocumentList());
      if (payload.mode === "add") {
        SuccessCreate();
      } else if (payload.mode === "edit") {
        SuccessUpdate();
      }
    } else {
      throw new Error("invalid save item, cannot be null");
    }
  } catch (error) {
    yield put(action.saveAddeditMasterDocumentError(error));
  }
}

function* deleteMasterDocument({ payload }) {
  try {
    if (payload && payload.confirmed) {
      if (payload.item) {
        yield call(deleteMasterDocumentAsync, payload.item.id);
        yield put(action.deleteMasterDocumentSuccess());
        yield put(action.loadMasterDocumentList());
        SuccessDelete();
      } else {
        throw new Error("invalid delete item, cannot be null");
      }
    }
  } catch (error) {
    yield put(action.deleteMasterDocumentError(error));
  }
}

export function* watchLoadMasterDocumentList() {
  yield takeEvery(action.LOAD_MASTER_DOCUMENT_LIST, loadMasterDocumentList);
}

export function* watchSaveAddeditMasterDocument() {
  yield takeEvery(action.SAVE_ADDEDIT_MASTER_DOCUMENT, saveAddeditMasterDocument);
}

export function* watchDeleteMasterDocument() {
  yield takeEvery(action.DELETE_MASTER_DOCUMENT, deleteMasterDocument);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoadMasterDocumentList),
    fork(watchSaveAddeditMasterDocument),
    fork(watchDeleteMasterDocument),
  ]);
}
